import { DisaggregatedMetric } from "../services/types";

export const processData = (dataItem: DisaggregatedMetric, filterId?: number) => {
    const version = dataItem.versions[0];
    if (!version) return [];

    const tallyMap = new Map<string, number>();
    const rawValueMap = new Map<string, number | string>();

    const disaggregations = filterId 
    ? version.disaggregations.filter(d => d.id === filterId) 
    : version.disaggregations;

    disaggregations.forEach(d => {
        let percentage;
        let rawValue;

        switch (version.unit) {
            case 'integer':
                percentage = d.value / version.value;
                rawValue = d.value;
                break;
            case 'percentage':
                percentage = Math.min(d.value, 1);
                rawValue = d.percent_calc?.n ?? 0;
                break;
            case 'decimal':
                percentage = d.value;
                rawValue = d.value;
                break;
            case 'ratio':
                const n = d.percent_calc?.n;
                const dValue = d.percent_calc?.d;
                if (n === undefined || dValue === undefined || dValue === 0) {
                    percentage = 0;
                    rawValue = '0:0';
                } else {
                    const gcd = (a: number, b: number): number => b === 0 ? a : gcd(b, a % b);
                    const greatestCommonDivisor = gcd(n, dValue);
                    percentage = (n / greatestCommonDivisor) / (dValue / greatestCommonDivisor);
                    rawValue = `${n / greatestCommonDivisor}:${dValue / greatestCommonDivisor}`;
                }
                break;
            default:
                percentage = 0;
                rawValue = '0';
        }

        tallyMap.set(d.name.trim(), percentage);
        rawValueMap.set(d.name.trim(), rawValue);
    });

    return Array.from(tallyMap.entries()).map(([name, percentage]) => ({
        label: name,
        value: percentage,
        rawValue: rawValueMap.get(name) ?? 0,
    }));
};

// skipHistogram - array of metric ids to exclude from generating histogram in metadata modal
export const skipHistogram: number[] = [1228, 1222, 1205, 1230, 1232];

// noDataPlugin - plugin to display a 'no data available' message inside of a chart 
export const noDataPlugin = {
    id: 'noData',
    afterDatasetsDraw: (chart: any) => {
        const { ctx, data, chartArea, options } = chart;
        const { top, left, width, height } = chartArea;

        ctx.save();

        // Check if the datasets array is empty or if all data values are 0 or NaN (charts using percentages / 0)
        const noData = data.datasets.length === 0 || 
            data.datasets[0].data.every((value: any) => value === 0 || isNaN(value));

        if (noData) {
            // Hide axis labels dynamically
            if (options.scales) {
                options.scales.x.ticks.display = false;
                options.scales.y.ticks.display = false;
                options.scales.x.grid.drawTicks = false;
                options.scales.y.grid.drawTicks = false;
            }

            // style the no data available container
            ctx.fillStyle = '#E5E7EB';
            ctx.fillRect(left, top, width, height);

            ctx.font = 'bold 12px Inter, system-ui, Avenir, Helvetica, Arial, sans-serif';
            ctx.fillStyle = 'black';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillText('No Data Available', left + width / 2, top + height / 2);
        }
        ctx.restore();
    }
};